export class ContextualPricing {
    isposvalidated: boolean;
    issyndicated: boolean;
}
